export const areaToPrefTable = [
  {
    name: '北海道',
    key: 'hokkaido',
    pref_list: [
      { name: '道央', key: 'douou' },
      { name: '道南', key: 'dounan' },
      { name: '道北', key: 'douhoku' },
      { name: '道東', key: 'doutou' }
    ]
  },
  {
    name: '東北',
    key: 'tohoku',
    pref_list: [
      { name: '青森', key: 'aomori' },
      { name: '岩手', key: 'iwate' },
      { name: '秋田', key: 'akita' },
      { name: '宮城', key: 'miyagi' },
      { name: '山形', key: 'yamagata' },
      { name: '福島', key: 'fukushima' }
    ]
  },
  {
    name: '関東',
    key: 'kanto',
    pref_list: [
      { name: '東京', key: 'tokyo' },
      { name: '神奈川', key: 'kanagawa' },
      { name: '埼玉', key: 'saitama' },
      { name: '千葉', key: 'chiba' },
      { name: '茨城', key: 'ibaraki' },
      { name: '栃木', key: 'tochigi' },
      { name: '群馬', key: 'gunma' }
    ]
  },
  {
    name: '中部',
    key: 'chubu',
    pref_list: [
      { name: '静岡', key: 'shizuoka' },
      { name: '愛知', key: 'aichi' },
      { name: '岐阜', key: 'gifu' },
      { name: '山梨', key: 'yamanashi' },
      { name: '長野', key: 'nagano' },
      { name: '新潟', key: 'niigata' },
      { name: '富山', key: 'toyama' },
      { name: '石川', key: 'ishikawa' },
      { name: '福井', key: 'fukui' }
    ]
  },
  {
    name: '近畿',
    key: 'kinki',
    pref_list: [
      { name: '大阪', key: 'osaka' },
      { name: '兵庫', key: 'hyogo' },
      { name: '京都', key: 'kyoto' },
      { name: '滋賀', key: 'shiga' },
      { name: '奈良', key: 'nara' },
      { name: '和歌山', key: 'wakayama' },
      { name: '三重', key: 'mie' }
    ]
  },
  {
    name: '中国',
    key: 'chugoku',
    pref_list: [
      { name: '広島', key: 'hiroshima' },
      { name: '岡山', key: 'okayama' },
      { name: '山口', key: 'yamaguchi' },
      { name: '島根', key: 'shimane' },
      { name: '鳥取', key: 'tottori' }
    ]
  },
  {
    name: '四国',
    key: 'shikoku',
    pref_list: [
      { name: '香川', key: 'kagawa' },
      { name: '徳島', key: 'tokushima' },
      { name: '愛媛', key: 'ehime' },
      { name: '高知', key: 'kouchi' }
    ]
  },
  {
    name: '九州',
    key: 'kyushu',
    pref_list: [
      { name: '福岡', key: 'fukuoka' },
      { name: '佐賀', key: 'saga' },
      { name: '長崎', key: 'nagasaki' },
      { name: '大分', key: 'oita' },
      { name: '熊本', key: 'kumamoto' },
      { name: '宮崎', key: 'miyazaki' },
      { name: '鹿児島', key: 'kagoshima' }
    ]
  },
  {
    name: '沖縄',
    key: 'okinawa',
    pref_list: []
  }
]
